<template>
  <a :href="data.link" class="item" target="_blank" rel="noopener noreferrer">
    <div class="thumbnail">
      <img v-lazy="data.thumbnail" alt="thumbnail" />
    </div>
    <div class="content">
      <h3 class="title wrap-text-2">{{ data.title }}</h3>
      <div class="author">{{ data.author }}</div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  display: block;
  .thumbnail {
    height: 380px;
    img {
      width: auto;
      height: 100%;
      max-width: 100%;
      border-radius: 5px;
      object-fit: cover;
      transition: var(--transition);
    }

    @media (max-width: 768px) {
      height: 300px;
    }
  }
  .content {
    padding: 0.6rem;
    padding-bottom: 0;
    margin-bottom: 1.2rem;
    .title {
      font-size: 1.2rem;
      line-height: 1.1;
      font-weight: bold;
      font-family: var(--font-family);
      margin-bottom: 0;
      color: var(--dark);
      transition: var(--transition);
    }

    .author {
      margin-top: 0.2rem;
      font-size: 0.9rem;
      font-weight: 500;
      color: var(--dark);
      opacity: 0.6;
      margin-right: 0.5rem;
    }
  }

  &:hover {
    .thumbnail img {
      transform: scale(1.01);
    }
    .content .title {
      color: var(--primary);
    }
  }
}
</style>